import React, { useContext, useState } from "react";
import { TeamManagementContext } from "./teammanagementContext";
import { setBulkAttendanceCriteria } from './service';
import Dropdown from 'react-dropdown';
import styles from "../../assets/stylesheets/pages/teammanagement/teamlead.module.scss";
import FormInput from "../../uicomponents/form-input/forminput";
import FutworkButton from "../../uicomponents/button";
import checkIsEmpty from "../../helper/checkIsEmpty";
import { InfoIcon } from "../../assets/images";
// import '../../assets/stylesheets/pages/tools.scss';

const criteraParameter = [
    {label: 'Connected Attempts (count)', value: 'connectedAttempts'},
    {label: 'Spoken Min (in minutes)', value: 'spokenMin'},
    {label: 'Working Time (in hrs & mins)', value: 'productiveTime'},
    {label: 'Call Attempts (count)', value: '(connectedAttempts + notConnectedAttempts)'}
];

const hoursList = [
    {label: '0 Hr', value: 0},
    {label: '1 Hr', value: 1},
    {label: '2 Hrs', value: 2},
    {label: '3 Hrs', value: 3},
    {label: '4 Hrs', value: 4},
    {label: '5 Hrs', value: 5},
    {label: '6 Hrs', value: 6},
    {label: '7 Hrs', value: 7},
    {label: '8 Hrs', value: 8},
    {label: '9 Hrs', value: 9},
    {label: '10 Hrs', value: 10}
];

const minuteList = [
    {label: '00 Min', value: 0},
    {label: '30 Mins', value: 30}
];

const BulkAttendanceCriteria = (props) => {
    const { teamSelected } = useContext(TeamManagementContext);
    const [step, setStep] = useState(1);
    const [criteriaParameterSelected, setCriteriaParameterSelected] = useState({ parameter: '', threshold: '' });
    const [inputAdded, setInputAdded] = useState(false);
    const [duration, setDuration] = useState({ hours: 0, mins: 0, totalsecs: 0 });
    const [apiMsg, setApiMsg] = useState({ type: '', msg: '' });
    const [mobileNumbersText, setMobileNumbersText] = useState('');
    const [loading, setLoading] = useState(false);

    const validateThreshold = () => {
        if(criteriaParameterSelected.threshold === ''){
            setApiMsg({ type: 'error', msg: `Please add threshold value` });
            return false;
        } else if(/^\d*$/.test(criteriaParameterSelected.threshold)){
            setApiMsg({ type: '', msg: '' });
            return true;
        } else {
            setApiMsg({ type: 'error', msg: `Invalid threshold value` });
            return false;
        }
    };

    const checkIfWorkingTimeParameter = () => criteriaParameterSelected.parameter === 'productiveTime';

    const selectedMins = minuteList.find(({value}) => value === duration.mins) || minuteList[0];
    const selectedHrs = hoursList.find(({value}) => value === duration.hours) || hoursList[0];

    const handleNext = () => {
        if (!criteriaParameterSelected.parameter) {
            setApiMsg({ type: 'error', msg: 'Please select a parameter' });
            return;
        }
        if (!validateThreshold()) return;
        setApiMsg({ type: '', msg: '' });
        setStep(2);
    };

    const handleBack = () => {
        setStep(1);
        setApiMsg({ type: '', msg: '' });
    };

    const parseMobileNumbers = (text) => {
        // Split by comma, newline, or space, filter valid numbers
        return text
            .split(/\s|,|\n/)
            .map(num => num.trim())
            .filter(num => num.length > 0);
    };

    const handleSubmit = async () => {
        const mobileNumbers = parseMobileNumbers(mobileNumbersText);
        if (mobileNumbers.length === 0) {
            setApiMsg({ type: 'error', msg: 'Please enter at least one mobile number.' });
            return;
        }

        // Validation for maximum 100 mobile numbers
        if (mobileNumbers.length > 100) {
            setApiMsg({ type: 'error', msg: 'Mobile Number should be less than 100' });
            return;
        }

        // Validation for alphanumeric (non-digit) numbers
        const alphaNumericNumbers = mobileNumbers.filter(num => /[^0-9]/.test(num));
        if (alphaNumericNumbers.length > 0) {
            setApiMsg({ type: 'error', msg: `Enter 10 digit valid Mobile Number: ${alphaNumericNumbers.join(', ')}` });
            return;
        }

        // Validation for 10-digit numbers
        const invalidNumbers = mobileNumbers.filter(num => !/^[0-9]{10}$/.test(num));
        if (invalidNumbers.length > 0) {
            setApiMsg({ type: 'error', msg: `Invalid mobile numbers: ${invalidNumbers.join(', ')}` });
            return;
        }

        // Validation for repeated numbers
        const numberCount = {};
        const repeatedNumbers = [];
        mobileNumbers.forEach(num => {
            numberCount[num] = (numberCount[num] || 0) + 1;
        });
        Object.keys(numberCount).forEach(num => {
            if (numberCount[num] > 1) {
                repeatedNumbers.push(num);
            }
        });
        if (repeatedNumbers.length > 0) {
            setApiMsg({ type: 'error', msg: `Repeated mobile numbers: ${repeatedNumbers.join(', ')}` });
            return;
        }

        setLoading(true);
        setApiMsg({ type: '', msg: '' });
        try {
            const payload = {
                mobileNumbers,
                attendanceCriteria: `${criteriaParameterSelected.parameter} >= ${criteriaParameterSelected.threshold}`,
                teamLeadId: (teamSelected && teamSelected.id) || (teamSelected && teamSelected.teamLeadId)
            };
            const result = await setBulkAttendanceCriteria(payload);
            if(result.status === 200){
                setApiMsg({ type: 'success', msg: (result.data && result.data.msg) || 'Bulk attendance criteria updated successfully.' });
                setMobileNumbersText('');
            } else {
                const errorMsg = (result.data && (result.data.msg || result.data.error)) || 'Something went wrong.';
                const formattedError = errorMsg.split('\n').join('\n');
                setApiMsg({ type: 'error', msg: formattedError });
            }
        } catch (error) {
            const errorMsg = (error && error.response && error.response.data && (error.response.data.msg || error.response.data.error)) || 'Something went wrong.';
            const formattedError = errorMsg.split('\n').join('\n');
            setApiMsg({ type: 'error', msg: formattedError });
        } finally {
            setLoading(false);
        }
    };

    const isNextDisabled =
        !criteriaParameterSelected.parameter ||
        !criteriaParameterSelected.threshold ||
        !/^\d+$/.test(criteriaParameterSelected.threshold);

    // Add a variable to check if at least one valid mobile number is present
    const hasAtLeastOneMobile = parseMobileNumbers(mobileNumbersText).length > 0;

    return (
        <div className={'modalSidebarContainer'}>
            <div className={styles.contentArea}>
                {step === 1 && (
                    <>
                        <div className={styles['dotted-border']}>
                            <div>
                                <b>Parameter</b>
                                <Dropdown
                                    options={criteraParameter}
                                    onChange={(e) => {
                                        if(!inputAdded) setInputAdded(true);
                                        setCriteriaParameterSelected({ ...criteriaParameterSelected, parameter: e.value });
                                        setApiMsg({ type: '', msg: '' });
                                    }}
                                    placeholder="Select parameter"
                                    className={styles['paramter_dropdown']}
                                    value={criteraParameter.find(({ value }) => criteriaParameterSelected.parameter === value) ? criteriaParameterSelected.parameter : ''}
                                />
                            </div>
                            <div>
                                <b>Threshold Values</b>
                                {checkIfWorkingTimeParameter() ? (
                                    <div style={{display: 'flex', gap: '0.5em'}}>
                                        <Dropdown
                                            options={hoursList}
                                            onChange={(e) => {
                                                if(!inputAdded) setInputAdded(true);
                                                const convetHrsToSeconds = e.value * 3600;
                                                const convertMinsToSeconds = duration.mins * 60;
                                                const totalsecs = convetHrsToSeconds + convertMinsToSeconds;
                                                setDuration({ ...duration, hours: e.value, totalsecs });
                                                setCriteriaParameterSelected({ ...criteriaParameterSelected, threshold: totalsecs });
                                                if(e.value > 0){
                                                    setApiMsg({ type: '', msg: '' });
                                                }
                                            }}
                                            placeholder="Select Hr(s)"
                                            className={styles['threshold_dropdown']}
                                            value={selectedHrs}
                                        />
                                        <Dropdown
                                            options={minuteList}
                                            onChange={(e) => {
                                                if(!inputAdded) setInputAdded(true);
                                                const convetHrsToSeconds = duration.hours * 3600;
                                                const convertMinsToSeconds = e.value * 60;
                                                const totalsecs = convetHrsToSeconds + convertMinsToSeconds;
                                                setDuration({ ...duration, mins: e.value, totalsecs });
                                                setCriteriaParameterSelected({ ...criteriaParameterSelected, threshold: totalsecs });
                                            }}
                                            placeholder="Select Min(s)"
                                            className={styles['threshold_dropdown']}
                                            value={selectedMins}
                                        />
                                    </div>
                                ) : (
                                    <FormInput
                                        helperIcon={false}
                                        type="number"
                                        key={'threshold'}
                                        onChange={(e) => {
                                            if(!inputAdded) setInputAdded(true);
                                            setCriteriaParameterSelected({ ...criteriaParameterSelected, threshold: e.target.value });
                                            if(e.target.value === ''){
                                                setApiMsg({ type: '', msg: '' });
                                            }
                                        }}
                                        value={criteriaParameterSelected.threshold}
                                    />
                                )}
                            </div>
                        </div>
                    </>
                )}
                {step === 2 && (
                    <div className={styles['dotted-border']}>
                        <div style={{width: '100%'}}>
                            <b>Enter Agent's Mobile Numbers</b>
                            <textarea
                                style={{ width: '100%', minHeight: '120px', marginTop: '8px', marginBottom: '8px', padding: '8px', fontSize: '1em', boxSizing: 'border-box' }}
                                placeholder="Enter Agent's Mobile Numbers separated by comma  or newline"
                                value={mobileNumbersText}
                                onChange={e => setMobileNumbersText(e.target.value)}
                                disabled={loading}
                            />
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            <div style={{ fontSize: '13px', color: '#555', marginTop: '4px' }}>
                                <b>NOTE:</b> Maximum limit is 100 Mobile Numbers
                            </div>
                            <div style={{ fontSize: '13px', color: '#555', marginTop: '2px' }}>
                                Mobile Numbers : {parseMobileNumbers(mobileNumbersText).length}
                            </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className={styles['user-note']} style={{marginTop: '1em'}}>
                    <img src={InfoIcon} width={"18px"} alt="info"/> For advanced configurations, raise an MT request.
                </div>
            </div>
            <div className={styles['criteria-footer']}>
                <div className={styles['first-child']}>
                    {!checkIsEmpty(apiMsg) && apiMsg.type && (
                        apiMsg.type === 'error' && typeof apiMsg.msg === 'string' && apiMsg.msg.includes('\n') ? (
                            apiMsg.msg.split('\n').map((line, idx) => (
                                <div key={idx} className={styles['error-msg']}>{line}</div>
                            ))
                        ) : (
                            <div className={apiMsg.type === 'success' ? styles['success-msg'] : styles['error-msg']}>
                                {apiMsg.msg}
                            </div>
                        )
                    )}
                </div>
                <div className={styles['second-child']}>
                    {step === 1 ? (
                        <>
                            <FutworkButton
                                buttonStyle="primary--outline non-rounded"
                                buttonSize="sm"
                                onClick={() => props.setShowAttendanceCriteria(false)}
                            >
                                Cancel
                            </FutworkButton>
                            <FutworkButton buttonStyle='navy--solid non-rounded' buttonSize="sm" onClick={handleNext} disabled={isNextDisabled}>Next</FutworkButton>
                        </>
                    ) : (
                        <>
                            <FutworkButton buttonStyle="primary--outline non-rounded" buttonSize="sm" onClick={handleBack} disabled={loading}>Back</FutworkButton>
                            <FutworkButton buttonStyle='navy--solid non-rounded' buttonSize="sm" onClick={handleSubmit} disabled={loading || !hasAtLeastOneMobile}>Submit</FutworkButton>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BulkAttendanceCriteria;
